import { Bug, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useI18n } from "@/contexts/I18nContext";

const ReportBug = () => {
  const { t } = useI18n();

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <div className="page-container mx-auto py-12 space-y-8">
        <div className="glass-card p-8 space-y-4">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
            <Bug className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-3xl font-bold">{t('support.bug.titlePage')}</h1>
          <p className="text-muted-foreground">
            {t('support.bug.subtitlePage')}
          </p>
        </div>

        <form className="glass-card p-8 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label>{t('support.contact.name')}</Label>
              <Input placeholder={t('support.contact.namePlaceholder')} />
            </div>
            <div>
              <Label>{t('support.contact.email')}</Label>
              <Input type="email" placeholder="email@domain.com" />
            </div>
          </div>
          <div>
            <Label>{t('support.bug.pageModule')}</Label>
            <Input placeholder={t('support.bug.pageModulePlaceholder')} />
          </div>
          <div>
            <Label>{t('support.bug.description')}</Label>
            <Textarea placeholder={t('support.bug.descriptionPlaceholder')} className="min-h-[140px]" />
          </div>
          <Button className="gap-2">
            <Send className="w-4 h-4" />
            {t('support.bug.send')}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ReportBug;
